import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { ClientesRelatoriosSemMovimentacao, FiltrosClientesRelatorios } from '@app/pages/relatorios/clientes/clientes-relatorios';
import { IdDescricao } from '@app/models/util/id-descricao';
import { ConsultasService } from '@app/services/consultas.service';
import { RelatorioService } from '../../../../services/relatorio.service';
import { ToastrService } from 'ngx-toastr';
import { UtilitarioService } from '@app/services/utilitario.service';

@Component({
  selector: 'app-clientes-sem-movimentacao',
  templateUrl: './clientes-sem-movimentacao.component.html',
  styleUrls: ['./clientes-sem-movimentacao.component.scss']
})

export class ClientesSemMovimentacaoComponent implements OnInit {

  lstUnidades: IdDescricao[] = [];
  filtros: FiltrosClientesRelatorios;
  listaClientes: ClientesRelatoriosSemMovimentacao[] = [];
  totalSemMovimentacao: number = 0;

  pesquisando = false;
  showTable: boolean = false;
  @ViewChild('relatorio') relatorio: ElementRef;
  hoje: Date;
  dataInicio : Date;
  dataFinal : Date;

  dataRelatorio: Date;

  constructor(
    private consultasService: ConsultasService,
    private relatorioService: RelatorioService,
    @Inject(ToastrService) public toastr: ToastrService
  ) {
    this.filtros = {
      UnidadeId: '0',
      Opcao: 1,
      QuantidadeRegistros: 10,
      InicioSemMovimentacao: 15,
      FinalSemMovimentacao: 30,
    };
  }

  ngOnInit() {
    this.consultasService
      .consultar('UNIDADE_S_RATEIO').toPromise()
      .then(data => this.lstUnidades = data);
      this.calculaIntervaloData();
  }

  private _bloqueioPeriodoGrande() {
    let periodoGrande: boolean = this.filtros.FinalSemMovimentacao - this.filtros.InicioSemMovimentacao > 400;
    
    return periodoGrande;
  }

  pesquisar() {
    if(this._bloqueioPeriodoGrande()) {
      this.toastr.warning("Período maior que 400 dias.", "Reduza o período de consulta");
      return;
    }

    this.dataRelatorio = new Date();
    this.pesquisando = true;

    this.relatorioService
      .clientes(this.filtros)
      .toPromise()
      .then(data => {
        this.listaClientes = data.Dados;
        this.totalSemMovimentacao = data.Total;
        this.pesquisando = false;

        if (this.listaClientes.length == 0) {
          this.showTable = false;
          this.toastr.info("Busca não encontrou resultados");
        } else {
          this.showTable = true;
        }
      }, erro => {
        this.pesquisando = false;
        this.toastr.warning("Realize a pesquisa novamente.")
      });
  }
  public imprimir() {
    let conteudo = document.getElementById("clienteProcesso").innerHTML;
    UtilitarioService.imprimirHTML(conteudo, "Relatório processo sem movimentação", this.montaImpressaoFiltros());
  }

  private montaImpressaoFiltros(){
    let objetoFiltros = new Map<string, string>();

    objetoFiltros.set('Emitido em', this.dataRelatorio.toLocaleString());
    objetoFiltros.set('Data Inicial', this.dataFinal.toLocaleDateString());
    objetoFiltros.set('Data Final', this.dataInicio.toLocaleDateString());

    if(this.filtros.UnidadeId)
    {
      let valor = this.lstUnidades.find(x => x.Id === Number(this.filtros.UnidadeId)).Descricao;
      objetoFiltros.set('Unidade', valor);
    }

    let stringHtml = '';

    objetoFiltros.forEach((valor, chave) => {
      stringHtml += `<tr><td>${chave}</td><td>${valor}</td></tr>`;
    })
    
    return stringHtml;
  }

  calculaIntervaloData(){
    this.hoje = new Date();
    this.dataInicio = new Date();
    this.dataFinal= new Date();

    this.dataInicio.setDate(this.hoje.getDate() - this.filtros.InicioSemMovimentacao);
    this.dataFinal.setDate(this.hoje.getDate() - this.filtros.FinalSemMovimentacao);
  } 
}
